import { render, staticRenderFns } from "./DiscountCoupon.vue?vue&type=template&id=d2588ad0&scoped=true&"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js&"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCoupon.vue?vue&type=style&index=0&id=d2588ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2588ad0",
  null
  
)

export default component.exports